
<antim-autoware-top-nav [isMenuOpen]="isMenuOpen" (menuToggle)="menuToggle($event)"></antim-autoware-top-nav>
<div class="main">
    <div class="side-menu" [ngClass]="{'menuClose': !isMenuOpen}">
        <antim-autoware-side-nav [isMenuOpen]="isMenuOpen" (menuToggle)="menuToggle($event)"></antim-autoware-side-nav>
    </div>
    <div class="content">
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div (click)="menuToggle(false)" [ngClass]="{'drawer-overlay': isMenuOpen}"></div>